import { useJotBillAccess } from '@features/billing/hooks/useJotBillAccess';
import { useCan } from '@features/user';
import { useOrganizationId } from '@features/user/store/hooks';
import { FeatureGates, useFeatureGate } from '@services/statsig';

export function useRevenueAccess(): boolean {
  const analytics = useFeatureGate(FeatureGates.JOTBILL_ANALYTICS);
  const workbench = useFeatureGate(FeatureGates.JOTBILL_CLAIM_WORKBENCH);
  const { hasAccess } = useJotBillAccess();
  const canManage = useCan('manage_billing');
  const organizationId = useOrganizationId();
  return analytics && workbench && hasAccess && canManage && !!organizationId;
}
